import { useCallback, useState } from 'react';
import { ButtonConfig, ConfirmPromptProps } from '../Abstracts/Components/ConfirmPrompt';

export interface UseConfirmPromptConfig {
	title?: string;
	text: string | React.ReactNode;
	icon?: string;
	confirmButton?: ButtonConfig;
	cancelButton?: ButtonConfig;
	onConfirm: () => void | Promise<void>;
	onCancel?: () => void;
}

export interface UseConfirmPromptReturn {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	promptProps: Omit<ConfirmPromptProps, 'open' | 'onClose'>;
}

export default function useConfirmPrompt(config: UseConfirmPromptConfig): UseConfirmPromptReturn {
	const [isOpen, setIsOpen] = useState(false);

	const open = useCallback(() => {
		setIsOpen(true);
	}, []);

	const close = useCallback(() => {
		setIsOpen(false);
	}, []);

	const promptProps: Omit<ConfirmPromptProps, 'open' | 'onClose'> = {
		title: config.title,
		text: config.text,
		icon: config.icon,
		confirmButton: config.confirmButton,
		cancelButton: config.cancelButton,
		onConfirm: config.onConfirm,
		onCancel: config.onCancel,
	};

	return {
		isOpen,
		open,
		close,
		promptProps,
	};
}
